export default __webpack_public_path__ + "static/teams-f58649f0cab514db9c68df27d6bb74cf.png";